var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class NmcsRules {
  constructor(initialState) {
    __publicField(this, "initialState");
    this.initialState = initialState;
  }
  /** optional method for implementing a cost of an action
   * the cost will be used only for the action decision that
   * is currently being considered in the nested search.
   * By default this returns 0, and so has no effect.
   */
  getActionCost(_action) {
    return 0;
  }
  /** the default policy is to pick a valid action randomly
   * this can be overriden to use a "heavy playout" strategy
   * which biases to include some domain specific knowledge
  */
  pickActionWithPolicy(validActions, rng) {
    const action = validActions[Math.floor(rng() * validActions.length)];
    return action;
  }
}
export {
  NmcsRules
};
//# sourceMappingURL=index133.js.map
